<template>
  <LineChartGenerator
    :chart-options="ruleChartOptions"
    :chart-data="ruleChartData"
    :chart-id="chartId"
    :plugins="plugins"
    :width="width"
    :height="height" />
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy';
// import { api } from '@/f1/service';

let backgroundColor = (ctx) => {
  const canvas = ctx.chart.ctx;
  const gradient = canvas.createLinearGradient(0, 0, 0, 300);
  gradient.addColorStop(0, 'rgba(0, 182, 149, 0.1)');
  gradient.addColorStop(.4, 'rgba(140, 236, 219, 0.05)');
  gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
  return gradient;
};

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler,
} from 'chart.js'
import moment from 'moment-timezone';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler
)

export default {
  name: 'LineChart',
  components: {
    LineChartGenerator
  },
  props: {
    days : {
      type: Array,
      default: () => []
    },
    chartId: {
      type: String,
      default: 'line-chart'
    },
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 180
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    //WMDS Line Chart Data
    ruleChartData: {
      labels: [],
      datasets: [
        { label: 'URL', data: [], borderColor : '', backgroundColor: backgroundColor, },
        { label: 'HOST', data: [], borderColor : '', backgroundColor: backgroundColor, },
        { label: 'IP', data: [], borderColor : '', backgroundColor: backgroundColor, },

        { label: 'Regex', data: [], borderColor : '', backgroundColor: backgroundColor, },
        { label: 'Path', data: [], borderColor : '', backgroundColor: backgroundColor, },
        { label: 'SSDEEP', data: [], borderColor : '', backgroundColor: backgroundColor, },

        { label: 'Excutable', data: [], borderColor : '', backgroundColor: backgroundColor, },
        { label: 'HASH', data: [], borderColor : '', backgroundColor: backgroundColor, },
        { label: 'Webshell', data: [], borderColor : '', backgroundColor: backgroundColor, },
      ]
    },

    //WMDS Line Chart Options
    ruleChartOptions: {
      responsive: true,
      maintainAspectRatio: false,
      borderColor: '#00B695',
      borderWidth: '3',
      tension: 0.5,
      scales: { xAxis: { ticks: { autoSkip: false, color: '#000000', font: { family: 'system-ui', size: 14, weight: 'bold', } } }, yAxis: { grid: { display: false }, ticks: { display: true } } },
      plugins: { legend: { display: true, labels: { usePointStyle: true } }, filler: { propagate: false }, hover: { enabled: true } },
      fill: true,
      pointRadius: 4,
      pointBackgroundColor: '#00B695',
    },

    color : {

      url : '#1abc9c',
      host : '#e67e22',
      ip : '#e74c3c',

      regex : '#9b59b6',
      path : '#2980b9',
      ssdeep : '#f39c12',

      excute : '#c0392b',
      file : '#16a085',
      webshell : '#8e44ad',
    },

  }),

  methods: {
  },

  created() { },
  destroyed() { },
  mounted() {
    console.log('this.data',this.days, this.color)

    let days = this.days

    for (let i = 0; i < days.length; i++) {
      this.ruleChartData.labels.push(moment(days[i].date).format('YYYY-MM-DD'))
      this.ruleChartData.datasets[0].data.push(days[i].url)
      this.ruleChartData.datasets[0].pointBackgroundColor = this.ruleChartData.datasets[0].borderColor = this.color.url
      this.ruleChartData.datasets[1].data.push(days[i].host)
      this.ruleChartData.datasets[1].pointBackgroundColor = this.ruleChartData.datasets[1].borderColor = this.color.host
      this.ruleChartData.datasets[2].data.push(days[i].ip)
      this.ruleChartData.datasets[2].pointBackgroundColor = this.ruleChartData.datasets[2].borderColor = this.color.ip

      this.ruleChartData.datasets[3].data.push(days[i].regex)
      this.ruleChartData.datasets[3].pointBackgroundColor = this.ruleChartData.datasets[3].borderColor = this.color.regex
      this.ruleChartData.datasets[4].data.push(days[i].path)
      this.ruleChartData.datasets[4].pointBackgroundColor = this.ruleChartData.datasets[4].borderColor = this.color.path
      this.ruleChartData.datasets[5].data.push(days[i].file_ssdeep)
      this.ruleChartData.datasets[5].pointBackgroundColor = this.ruleChartData.datasets[5].borderColor = this.color.ssdeep

      this.ruleChartData.datasets[6].data.push(days[i].file_excute)
      this.ruleChartData.datasets[6].pointBackgroundColor = this.ruleChartData.datasets[6].borderColor = this.color.excute
      this.ruleChartData.datasets[7].data.push(days[i].file_hash)
      this.ruleChartData.datasets[7].pointBackgroundColor = this.ruleChartData.datasets[7].borderColor = this.color.hash
      this.ruleChartData.datasets[8].data.push(days[i].file_webshell)
      this.ruleChartData.datasets[8].pointBackgroundColor = this.ruleChartData.datasets[8].borderColor = this.color.webshell

    }
    // this.ruleChartOptions.pointBackgroundColor =
    // this.ruleChartOptions.pointBackgroundColor = this.ruleChartOptions.borderColor = ['#000080', '#FFDB58', '#808000', '#F5DEB3', '#FFC0CB', '#3BC3AB']
    // this.ruleChartOptions.borderColor = ['#000080', '#FFDB58', '#808000', '#F5DEB3', '#FFC0CB', '#3BC3AB']
    // console.log(this.ruleChartData.labels)
  }

}

</script>
